export default {
      id: "youtube-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "app/svg/sprite.svg#youtube",
      toString: function () {
        return this.url;
      }
    }